<div id="userspiediv" #userspiediv class="users-pie" [style.height.px]="height"></div>